@if (driver()) {
  <div class="row mx-0 p-1 border bg-light rounded">
    <div class="col-auto p-1">
      <p-avatar
        [label]="label()"
        class="text-primary mr-2"
        [style]="{ 'background-color': 'var(--p-primary-50)' }"
        size="large"
        shape="circle" />
    </div>
    <div class="col px-1">
      <div class="lh-sm">{{ driverName() }}</div>
      <div class="text-muted lh-sm small">Main driver</div>
    </div>
    <div class="col-auto px-1">
      <button
        type="button"
        class="p-0 btn btn-sm text-decoration-underline text-primary lh-sm align-top"
        (click)="editClicked.emit()">
        {{ dialogLabel() }}
      </button>
    </div>
  </div>
} @else {
  <div class="row mx-0 p-1 border bg-light rounded border-danger">
    <button type="button" class="btn h-100 w-100 text-muted" (click)="editClicked.emit()">
      <i class="fa fas fa-plus"></i>
      Add Driver
    </button>
  </div>
}
